import React from 'react'
import PropTypes from 'prop-types'
import Navigation from '../components/navigation'
import Footer from '../components/footer'
import VisibilitySensor from 'react-visibility-sensor'
import './project.scss'
import { Player } from 'video-react';

class Project extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      moreView: false
    }
  }

  componentDidMount() {
    const {history} = this.props;
    const {slug} = this.props.data.contentfulProject;
    if (history.location.hash !== '') {
      history.replace(`/${slug}`)
      history.goBack();
    }

    this.fadeInContent()
  }

  componentWillUnmount() {
    this.fadeOutContent()
  }

  render() {
    const {title, shortDescription, imagesAndVideos, longDescription, credits, slug} = this.props.data.contentfulProject;
    const activeView = this.state.moreView ? 'more-view' : 'landing-view';

    return (
      <div className={`project-view-wrapper ${activeView}`}>
        <div className="more-view-wrapper">
          <h1 className="desktop-only more-view-title">{title}</h1>
          <button onClick={this.handleClose.bind(this)}>
            {<span>&times;</span>}
          </button>

          <h1 className="mobile-only mobile-title">
            {title}
            <br/>
            {shortDescription}
          </h1>

          <div
            className="long-description"
            dangerouslySetInnerHTML={{
              __html: longDescription.childMarkdownRemark.html,
            }} />

          <div
            className="credits"
            dangerouslySetInnerHTML={{
              __html: credits.childMarkdownRemark.html,
            }} />

          <Navigation
            linkData={this.props.data.allContentfulCategory.edges} />

          <Footer
            footerData={this.props.data.contentfulFooter} />
        </div>

        <div className="landing-view-wrapper">
          <h2 className="more-info" onClick={this.handleClick.bind(this)}>
            ...MORE INFO
          </h2>

          <h1 id="project-title" className="desktop-only">{title}</h1>

          {imagesAndVideos.length > 0 &&
            imagesAndVideos.map((asset, i) => {
              if (asset.file.contentType === 'video/mp4') {
                return (
                  <div key={`video-${i}`} className="asset-container">
                    <Player
                      playsInline
                      autoPlay
                      loop
                      muted
                      src={asset.file.url}>
                    </Player>
                  </div>
                )
              } else {
                return (
                  <div key={i} className="asset-container">
                    <img src={asset.file.url} />
                  </div>
                )
              }
            })
          }

          <Navigation linkData={this.props.data.allContentfulCategory.edges} />
          <VisibilitySensor offset={{top:300}} onChange={this.onChange.bind(this)} />
          <Footer footerData={this.props.data.contentfulFooter} />
        </div>
      </div>
    )
  }

  fadeInContent() {
    const wrapper = document.getElementById('content-wrapper');
    setTimeout(function() {
      wrapper.classList += ' visible';
    }, 600)
  }

  fadeOutContent() {
    const wrapper = document.getElementById('content-wrapper');
    if (wrapper.classList.contains('visible')) {
      wrapper.classList.remove('visible');
    }
  }

  handleClick() {
    this.setState({
      moreView: true
    })
  }

  handleClose() {
    this.setState({
      moreView: false
    })
  }

  onChange(isVisible) {
    const logo = document.getElementById("logo-area");
    const projectTitle = document.getElementById("project-title");

    if (isVisible) {
      logo.className += " fade-down";
      projectTitle.className += " fade-down";
    }

    if (!isVisible) {
      logo.classList.remove('fade-down')
      projectTitle.classList.remove('fade-down')
    }
  }
}

Project.propTypes = {
  data: PropTypes.object.isRequired
}

export default Project

export const pageQuery = graphql`
  query projectQuery($slug: String!){
    contentfulProject(slug: {eq: $slug}) {
      title
      slug
      shortDescription
      longDescription {
        childMarkdownRemark {
          html
        }
      }
      credits {
        childMarkdownRemark {
          html
        }
      }
      imagesAndVideos {
        ...ImageVideoList
      }
    }
    allContentfulCategory (limit: 100) {
      edges {
        node {
          name
          orderNumber
        }
      }
    }
    contentfulFooter {
      description {
        childMarkdownRemark {
          html
        }
      }
      contactInformation {
        childMarkdownRemark {
          html
        }
      }
    }
  }
  fragment ImageVideoList on ContentfulAsset {
    file {
      url
      fileName
      contentType
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/project.js